
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const fetchAppSettings = async () => {
  return await get<ApiResponse<any[]>>("/app-settings/public").then((res)=>{
      return res
    })
};

 